import ReactDOM from 'react-dom/client';

import { installDomSerializationGuard } from 'src/shared/utils/domSerializationGuard';

import App from './app';

// Guard against browser extensions that patch `appendChild` and call
// `JSON.stringify` on inserted nodes — which trips on React's fiber cycle.
installDomSerializationGuard();

// ResizeObserver loop notifications are benign browser events fired by floating-UI
// libraries (e.g. HeroUI popovers/autocomplete). Suppress them so they don't surface
// as React error overlays in development.
window.addEventListener('error', (e: ErrorEvent) => {
  if (
    e.message ===
    'ResizeObserver loop completed with undelivered notifications.'
  ) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(<App />);
